import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const lessonsAdapter = createEntityAdapter({})

const initialState = lessonsAdapter.getInitialState()

export const lessonsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getLessons: builder.query({
            query: ({all}) => {
                return {
                url: `/api/lessons${all ? '?all=true' : ''}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
                //params: all ? { all: "true" } : {}

                }
            },
            transformResponse: responseData => {
                const loadedLessons = responseData.map(lesson => {
                    lesson.id = lesson._id
                    return lesson
                });
                return lessonsAdapter.setAll(initialState, loadedLessons)
            }, 
                       
            // providesTags: (result, error, arg) => {
            //     if (result?.ids) {
            //         return [
            //             { type: 'Lesson', id: 'LIST' },
            //             ...result.ids.map(id => ({ type: 'Lesson', id }))
            //         ]
            //     } else return [{ type: 'Lesson', id: 'LIST' }]
            // }
        }),
        getSingleLesson: builder.query({
            query: (lessonId) => ({
                url: `/api/lessons/${lessonId}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            providesTags: (result, error, arg) => {
                //console.log("arg", arg)
                return [{ type: 'Lesson', id: arg }]
            }
        }),
        addNewLesson: builder.mutation({
            query: initialLessonData => ({
                url: '/api/lessons',
                method: 'POST',
                body: {
                    ...initialLessonData,
                }
            }),
            invalidatesTags: [
                { type: 'Lesson', id: "LIST" }
            ]
        }),
        updateLesson: builder.mutation({
            query: initialLessonData => ({
                url: '/api/lessons',
                method: 'PATCH',
                body: {
                    ...initialLessonData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Lesson', id: arg.id }
            ]
        }),
        deleteLesson: builder.mutation({
            query: ({ id }) => ({
                url: `/api/lessons`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Lesson', id: arg.id }
            ]
        }),
        markLessonsAsReport: builder.mutation({ 
            
            query: ({ids}) => ({
                url: '/api/lessons/report',
                method: 'POST',
                body:  {ids} 
            }),
            invalidatesTags: [
                { type: 'Lesson', id: "LIST" }
            ]
           
        }),
      
       
      
    }),
})

export const {
    useGetLessonsQuery,
    useGetSingleLessonQuery,
    useAddNewLessonMutation,
    useUpdateLessonMutation,
    useDeleteLessonMutation,   
    useMarkLessonsAsReportMutation 
} = lessonsApiSlice

// returns the query result object
export const selectLessonsResult = lessonsApiSlice.endpoints.getLessons.select()

// creates memoized selector
const selectLessonsData = createSelector(
    selectLessonsResult,
    lessonsResult => lessonsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllLessons,
    selectById: selectLessonById,
    selectIds: selectLessonIds
    // Pass in a selector that returns the lessons slice of state
} = lessonsAdapter.getSelectors(state => selectLessonsData(state) ?? initialState)